import { addFilter } from '@wordpress/hooks'
import { PanelBody, PanelRow, TextControl, Button, ButtonGroup, ColorPicker, ToggleControl, SelectControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { useSelect, dispatch } from '@wordpress/data'
import { useState } from '@wordpress/element'
import WPEditor from '../fields/WPEditor';

/**
 * Adding Multiple Partial Field.
 */
addFilter('wp_travel_after_minimum_partial_payout', 'wp-travel', (content) => {
    return [...content, WPTravelPartialPaySettings() ]
}, 20)

/**
 * Adding Partial Email Templates.
 */
addFilter('wp_travel_tab_content_after_email', 'wp-travel', (content) => {
    return [...content, PartialEmailTemplates() ]
}, 20)

/**
 * Callback function for above filter.
 */
const WPTravelPartialPaySettings = () => {

    const [payoutCount, setPayoutCount] = useState(1);

    /**
     * Get store settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    /**
     * Get wp travel admin data
     */
    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);

    const {
        minimum_partial_payout,
        partial_payment_amount,
        partial_payment
    } = allData

    const handleAdd = () => {
        const values = minimum_partial_payout;
        values.push( 1 );
        let count = payoutCount;
        updateSettings({
            ...allData,
            total_payout_fields : count++
        })
        setPayoutCount(count);
    }

    const handleRemove = () => {
        const values = minimum_partial_payout;
        values.pop();
        let count = payoutCount;
        updateSettings({
            ...allData,
            total_payout_fields : count--
        })
        setPayoutCount(count);
    }

    const style = { margin: '0 8px' }

    let total_percent = 0
    let partial_payouts = minimum_partial_payout;

    if (  'undefined' != typeof minimum_partial_payout && minimum_partial_payout.length > 0 ) {
        if ( 'string' == typeof minimum_partial_payout ) { // fixes for old partial payment saved as string.
            partial_payouts = [minimum_partial_payout]
        }
        total_percent = partial_payouts.reduce(function(a,b){
            return parseFloat(a) + parseFloat(b);
        }, 0);
    }
    return (
        <>
        { 'yes' == partial_payment  && partial_payment_amount == 'no' &&
            <>
            { (total_percent < 100 || total_percent > 100) && <PanelRow><label></label><div className="wp-travel-field-value"><p className="description notice-error notice">{_wp_travel.setting_strings.payment.partial_error_notice}</p></div></PanelRow> }
            <PanelRow>
                <span></span>
                <ButtonGroup>
                    {  ( total_percent < 100 && minimum_partial_payout.length < 10 ) &&
                        <Button style={style} isSecondary onClick={() => handleAdd()}>
                            {_wp_travel.setting_strings.payment.add_partial_payment}
                        </Button> 
                    }
                    { minimum_partial_payout.length > 1 &&
                        <Button isSecondary onClick={() => handleRemove()} style={{marginBottom: '25px'}}>
                            {_wp_travel.setting_strings.payment.remove_partial_payment}
                        </Button>
                    }
                </ButtonGroup>
            </PanelRow>
            </>
        }
        </>
    )
};

const PartialEmailTemplates = () => {
    const allData = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);

    const { updateSettings } = dispatch('WPTravel/Admin');

    const {
        partial_payment_admin_template,
        partial_payment_client_template,
        remaining_partial_payment_reminder,
        options
    } = allData;
const {email_cycle_option} = options;
    let sendPaymentNotification = 'undefined' != typeof remaining_partial_payment_reminder ? remaining_partial_payment_reminder.send_remaining_payment_notification : ''

    const updateEmailData = ( storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }   

    return (
        <>
            <PanelBody title={_wp_travel.setting_strings.email_tempaltes.partial_payment_email_templates} initialOpen={false} >
                <h3>{_wp_travel.setting_strings.email_tempaltes.admin_email_template_options}</h3>

                {/* Admin Email Part Start */}
                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_subject }</label>
                    <div className="wp-travel-field-value">
                        <TextControl
                            value={ 'undefined' != typeof partial_payment_admin_template ? partial_payment_admin_template.admin_subject : ''}
                            onChange={ 
                                (value) => { updateEmailData( 'partial_payment_admin_template', 'admin_subject', value ) }
                            }
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_title }</label>
                    <div className="wp-travel-field-value">
                        <TextControl
                            value={ 'undefined' != typeof partial_payment_admin_template ? partial_payment_admin_template.admin_title : ''}
                            onChange={ 
                                (value) => { updateEmailData( 'partial_payment_admin_template', 'admin_title', value ) }
                            }
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_header_color }</label>
                    <div className="wp-travel-field-value">
                        <ColorPicker
                            color={ 'undefined' != typeof partial_payment_admin_template ? partial_payment_admin_template.admin_header_color : ''}
                            onChangeComplete={ ( value ) => { updateEmailData( 'partial_payment_admin_template', 'admin_header_color', value.hex )} }
                            disableAlpha
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.email_content }</label>
                </PanelRow>
                <PanelRow className="wp-travel-editor">
                    {'undefined' !== typeof partial_payment_admin_template && <WPEditor id="partial_payment_admin_template" value={ 'undefined' != typeof partial_payment_admin_template ? partial_payment_admin_template.email_content : ''}
                    onContentChange={(value) => {
                        updateEmailData( 'partial_payment_admin_template', 'email_content', value )
                    }}  />}
                </PanelRow>

                {/* Admin Email Part End */}

                {/* Client Email Part Start */}
                <h3>{_wp_travel.setting_strings.email_tempaltes.client_email_template_options}</h3>
                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_subject }</label>
                    <div className="wp-travel-field-value">
                        <TextControl
                            value={ 'undefined' != typeof partial_payment_client_template ? partial_payment_client_template.client_subject : ''}
                            onChange={ 
                                (value) => { updateEmailData( 'partial_payment_client_template', 'client_subject', value ) }
                            }
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_title }</label>
                    <div className="wp-travel-field-value">
                        <TextControl
                            value={ 'undefined' != typeof partial_payment_client_template ? partial_payment_client_template.client_title : ''}
                            onChange={ 
                                (value) => { updateEmailData( 'partial_payment_client_template', 'client_title', value ) }
                            }
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_header_color }</label>
                    <div className="wp-travel-field-value">
                        <ColorPicker
                            color={ 'undefined' != typeof partial_payment_client_template ? partial_payment_client_template.client_header_color : ''}
                            onChangeComplete={ ( value ) => { updateEmailData( 'partial_payment_client_template', 'client_header_color', value.hex )} }
                            disableAlpha
                        />
                    </div>
                </PanelRow>

                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.email_content }</label>
                </PanelRow>
                <PanelRow className="wp-travel-editor">
                    {'undefined' !== typeof partial_payment_client_template && <WPEditor id="partial_payment_client_template" value={partial_payment_client_template.email_content}
                    onContentChange={(value) => {
                        updateEmailData( 'partial_payment_client_template', 'email_content', value )
                    }}  />}
                </PanelRow>

                {/* Client Email Part End */}

                {/* Remaining Partial Payment Reminder Part Start */}
                <h4>{_wp_travel.setting_strings.email_tempaltes.remaining_partial_payment_remainder}</h4>
                <PanelRow>
                    <label>{ _wp_travel.setting_strings.email_tempaltes.enable_remainder_notification }</label>
                    <div className="wp-travel-field-value">
                        <ToggleControl
                            checked={sendPaymentNotification == 'yes'}
                            onChange={ () => {
                                {updateEmailData( 'remaining_partial_payment_reminder', 'send_remaining_payment_notification', 'yes' == sendPaymentNotification ? 'no': 'yes' )}
                            }
                        }
                        />
                        <p className="description">{_wp_travel.setting_strings.email_tempaltes.enable_reenable_remainder_notification_noteainder_notification}</p>
                    </div>
                </PanelRow>

                { 
                    'yes' == sendPaymentNotification ?
                    <PanelBody>
                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.email_tempaltes.email_cycle }</label>
                            <div className="wp-travel-field-value">
                                <div className="wp-travel-select-wrapper">
                                    <SelectControl
                                        multiple={true}
                                        // options={[
                                        //     { value: 'once_in_four_days', label: 'Once in four days' },
                                        //     { value: 'once_in_seven_days', label: 'Once in seven days' },
                                        //     { value: 'once_in_fifteen_days', label: 'Once in fifteen days' }
                                        // ]}
                                        options={ email_cycle_option }
                                        value={ 'undefined' != typeof remaining_partial_payment_reminder.email_cycle  ? remaining_partial_payment_reminder.email_cycle : 'once_in_four_days'}
                                        onChange={ (value)=>{
                                            {updateEmailData( 'remaining_partial_payment_reminder', 'email_cycle', value )}
                                        }}
                                    />
                                </div>
                            </div>
                        </PanelRow>
        
                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.email_tempaltes.reminder_title }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={remaining_partial_payment_reminder.reminder_title}
                                    onChange={ 
                                        (value) => { updateEmailData( 'remaining_partial_payment_reminder', 'reminder_title', value ) }
                                    }
                                />
                            </div>
                        </PanelRow>
        
                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.email_tempaltes.payment_email_header_color }</label>
                            <div className="wp-travel-field-value">
                                <ColorPicker
                                    color={ remaining_partial_payment_reminder.reminder_header_color }
                                    onChangeComplete={ ( value ) => { updateEmailData( 'remaining_partial_payment_reminder', 'reminder_header_color', value.hex )} }
                                    disableAlpha
                                />
                            </div>
                        </PanelRow>
        
                        <PanelRow>
                            <label>{ _wp_travel.setting_strings.email_tempaltes.email_content }</label>
                        </PanelRow>
                        <PanelRow className="wp-travel-editor">
                            {'undefined' != typeof remaining_partial_payment_reminder && <WPEditor id="remaining_partial_payment_reminder" value={remaining_partial_payment_reminder.email_content}
                            onContentChange={(value) => {
                                updateEmailData( 'remaining_partial_payment_reminder', 'email_content', value )
                            }}  />}
                        </PanelRow>
                    </PanelBody> : ''
                }
                {/* Remaining Partial Payment Reminder Part End */} 
            </PanelBody>
        </>
    )
}